<!--
 * @Description: 跟进记录新增
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-05-31 17:58:57
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :permissionPage="permissionBasic" :archiveIds="route.query.archiveIds as Array<string>"/>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import baseMessage from '../components/baseMessage.vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const permissionBasic = {
  save: 'fbu_follow_add_btn'
}
</script>
<script lang="ts">
export default {
  name: 'DcCosFbuFollowUpRecordAdd'
}
</script>
